<template>
    <div id="login">
        <div class="overlay"></div>
        <div class="box-container">
            <div class="login-logo">
                <router-link to="/">
                    <div class="logo-bg-blur"></div>
                    <img src="/images/logo.png" alt="" />
                </router-link>
            </div>
            <form method="GET" @submit.prevent="submit">
                <div class="login-box">
                    <h2 class="login-title">Login</h2>
                    <div class="login-form">
                        <div class="login-input-group">
                            <h5>User</h5>
                            <input type="text" placeholder="Admin" v-model='username' />
                        </div>                       
                        <div class="login-input-group">
                            <h5>Password</h5>
                            <input type="password" placeholder="*********" v-model='password' />
                        </div>
                        <div v-if="loginFailed">
                            Username or Password Failed
                        </div>                       
                        <div class="login-input-group">
                            <button type="submit" class="btn-login">
                                Login Now
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
              username: null,
              password: null,
              loginFailed: null, 
              validation:null,           
        };
    },
    mounted() {
        this.loginFailed;
    },    
    methods: {
          submit() {     
              axios.post('../api/login', {
                  username: this.username,
                  password: this.password
                })
                .then(response => { 
                  let data = response.data; 
                    if(response.data.success) {
                        localStorage.setItem('token', response.data.token)
                        this.$router.push({ 
                             name: 'dashboard', 
                             params: {
                                 'token'    : response.data.token,
                                 'username' : response.data.username
                                 } 
                        });
                    }
                this.loginFailed = true                  
                })
               .catch(error => { 
                  this.error = error.response.data.error;
                });                 
          }     
    }
};
</script>

<style lang="scss" scoped>
::v-deep body {
    width: 100vw !important;
    height: 100vh !important;
    font-family: "Exo";

    overflow: hidden;
}

#login {
    font-family: "Exo";
    background-image: url("/images/admin-bg.jpg") !important;
    background-size: cover !important;
    width: 100vw !important;
    height: 100vh !important;
    overflow: hidden;
    color: #fff;

    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2;
        background: radial-gradient(
                58.82% 150.58% at 50% 62.61%,
                rgba(0, 0, 0, 0.2) 0%,
                rgba(0, 13, 23, 0.2) 75%,
                rgba(0, 64, 7, 0.2) 100%
            ),
            linear-gradient(
                180deg,
                rgba(0, 0, 0, 0.05) 26.7%,
                rgba(46, 158, 71, 0.05) 84.52%
            ),
            #171717 !important;
        width: 100vw;
        height: 100vh;
        opacity: 0.95;
    }

    .box-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 10;
        width: 100%;
        height: 100%;
        text-align: center;
    }

    .login-logo {
        position: relative;
        margin-bottom: 110px;

        a:hover img {
            opacity: 0.7;
        }

        // @media only screen and (min-width: 768px) {
        //     margin-bottom: 100px;
        // }

        // @media only screen and (min-width: 1440px) {
        //     margin-bottom: 7.638888888888889vw;
        // }

        .logo-bg-blur {
            filter: blur(35.5999968px);
            position: absolute;
            width: 129.188px;
            height: 17.594px;
            background: white;
            top: 5%;
            left: 10%;

            // @media only screen and (min-width: 1440px) {
            //     filter: blur(2.472222vw);
            //     width: 8.972222vw;
            //     height: 1.222222vw;
            // }
        }
        img {
            width: 158px;

            // @media only screen and (min-width: 1440px) {
            //     width: 10.972222222222221vw;
            // }
        }
    }

    .login-box {
        .login-title {
            font-family: Exo;
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 32px;
            margin-bottom: 60px;

            // @media only screen and (min-width: 768px) {
            //     margin-bottom: 60px;
            // }

            // @media only screen and (min-width: 1440px) {
            //     font-size: 1.6666666666666667vw;
            //     line-height: 2.2152777777777777vw;
            //     margin-bottom: 4.166666666666667vw;
            // }
        }

        .login-form {
            width: 70vw;
            text-align: left;
            width: 450px;
            // @media only screen and (min-width: 768px) {
            //     width: 450px;
            // }

            // @media only screen and (min-width: 1440px) {
            //     width: 31.25vw;
            // }

            .login-input-group {
                margin-bottom: 20px;

                // @media only screen and (min-width: 1440px) {
                //     margin-bottom: 1.3888888888888888vw;
                // }

                h5 {
                    font-size: 16px;
                    line-height: 21.26px;
                    margin-bottom: 8px;

                    // @media only screen and (min-width: 1440px) {
                    //     font-size: 1.1111111111111112vw;
                    //     line-height: 1.476388888888889vw;
                    //     margin-bottom: 0.5555555555555556vw;
                    // }
                }
                input[type="text"] {
                    width: 100%;
                    height: 50px;
                    border: 0.1px solid #e8e8e8;
                    border-radius: 5px;
                    background-color: transparent;
                    padding: 0 22px;
                    color: white;
                    font-size: 14px;

                    // @media only screen and (min-width: 1440px) {
                    //     height: 3.4722222222222223vw;
                    //     border-radius: 0.3472222222222222vw;
                    //     font-size: 0.9722222222222222vw;
                    //     padding: 0 1.52778vw;
                    // }
                }
                input[type="password"] {
                    width: 100%;
                    height: 50px;
                    border: 0.1px solid #e8e8e8;
                    border-radius: 5px;
                    background-color: transparent;
                    padding: 0 22px;
                    color: white;
                    font-size: 14px;

                    // @media only screen and (min-width: 1440px) {
                    //     height: 3.4722222222222223vw;
                    //     border-radius: 0.3472222222222222vw;
                    //     font-size: 0.9722222222222222vw;
                    //     padding: 0 1.52778vw;
                    // }
                }                
                .btn-login {
                    /* padding: 0.9722222222222222vw 1.7361111111111112vw;
                     */
                    background: linear-gradient(
                        208.27deg,
                        #6ee29f 0%,
                        #27ae60 95.3%
                    );
                    border: none;
                    border-radius: 20px;//1.3888888888888888vw;
                    width: 100%;
                    min-height: 40px;
                    height: 38px;
                    color: white;
                    font-size: 14px;
                    line-height: 12px;
                    font-family: "Bungee";
                    transition: all ease 0.3s;
                    margin-top: 10px;

                    &:hover {
                        background: linear-gradient(
                                0deg,
                                rgba(255, 255, 255, 0.05),
                                rgba(255, 255, 255, 0.05)
                            ),
                            linear-gradient(
                                208.27deg,
                                #6ee29f 0%,
                                #27ae60 95.3%
                            );
                        box-shadow: 2px 3px 6px rgba(42, 207, 59, 0.3);
                    }
                    &:active {
                        background: linear-gradient(
                                0deg,
                                rgba(255, 255, 255, 0.3),
                                rgba(255, 255, 255, 0.3)
                            ),
                            linear-gradient(
                                208.27deg,
                                #6ee29f 0%,
                                #27ae60 95.3%
                            );
                        box-shadow: 3px 5px 10px rgba(42, 207, 59, 0.3);
                    }

                    // @media only screen and (min-width: 1440px) {
                    //     font-size: 0.9722222222222222vw;
                    //     line-height: 0.8333333333333334vw;
                    //     height: 2.7777777777777777vw;
                    //     border-radius: 1.3888888888888888vw;
                    // }
                }
            }
        }
    }
}
</style>
